"use client";
import { useEffect } from "react";
import { useSession } from "@/lib/authClient";
import { setFavoritesAuth } from "@/lib/favorites";

// Relie l'état de session (Better Auth) au magasin de favoris : monté une seule
// fois au layout racine. Connexion → charge les favoris du compte ; déconnexion → vide.
export function FavoritesSync() {
  const { data } = useSession();
  // On dépend du BOOLÉEN, pas de l'objet session : `data` change de référence à
  // chaque rafraîchissement de session alors que l'état « connecté » est le même,
  // et chaque changement relançait un chargement des favoris.
  const isLoggedIn = !!data;
  useEffect(() => {
    setFavoritesAuth(isLoggedIn);
  }, [isLoggedIn]);
  return null;
}
